/* eslint-disable no-unused-vars */
import Vue from 'vue'

Vue.config.errorHandler = (err, vm, info) => {
  // if (process.env.NODE_ENV !== 'production') {
  console.error('Vue error:', err)
  console.error('Component:', vm)
  console.error('Info:', info)
  // }
}

window.onerror = (message, source, lineno, colno, error) => {
  // if (process.env.NODE_ENV !== 'production') {
  console.error('Window error:', message)
  console.error('Source:', source)
  console.error('Line:', lineno)
  console.error('Column:', colno)
  console.error('Error:', error)
  // }
}
